import { RegisterWrapper } from "./styled"
import Button from "components/Button"
import Input from "components/Input"
import { Link, useNavigate } from "react-router-dom"
import { useFormik } from "formik"
import * as Yup from "yup"
import { authError } from "errors/auth"
import { REGEX_PASSWORD, REGEX_PHONE_NUMBER } from "constants/regex"
import { useDispatch, useSelector } from "react-redux"
import { authSelector } from 'redux/selector'
import { authAction } from "redux/slice/authSlice"
import ShowToast from "utils/ShowToast"
import Loading from "components/Loading"

const Register = () => {
    const authState = useSelector(authSelector)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const formData = useFormik({
        initialValues: {
            account_name: "",
            phone_number: "",
            email: "",
            password: "",
            password_confirm: ""
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            account_name: Yup.string().trim().required(authError.requiredAccountName).min(4, authError.invalidAccountName),
            phone_number: Yup.string().trim().required(authError.requiredPhone).matches(REGEX_PHONE_NUMBER, authError.invalidPhone),
            email: Yup.string().trim().required(authError.requiredEmail).email(authError.invalidEmail),
            password: Yup.string().trim().required(authError.requiredPassword).matches(REGEX_PASSWORD, authError.invalidPassword),
            password_confirm: Yup.string().trim().required(authError.requiredPasswordConfirm).oneOf(
                [Yup.ref("password"), null],
                authError.invalidPasswordConfirm
            )
        }),
        onSubmit: (values, { setFieldError }) => {
            if (!authState.isFetching)
                dispatch(authAction.register({ values, setFieldError, navigate, ShowToast }))
        }
    })

    return (
        <RegisterWrapper className="flex-center pt-35">
            {
                authState.isFetching && <Loading />
            }
            <form onSubmit={formData.handleSubmit}>
                <h1 className="text-black s-24 bold text-center mb-50">ĐĂNG KÝ</h1>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Tên tài khoản"
                        name="account_name"
                        value={formData.values.account_name}
                        isError={!!formData.errors.account_name}
                        message={formData.errors.account_name}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Số điện thoại"
                        name="phone_number"
                        value={formData.values.phone_number}
                        isError={!!formData.errors.phone_number}
                        message={formData.errors.phone_number}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Email"
                        name="email"
                        value={formData.values.email}
                        isError={!!formData.errors.email}
                        message={formData.errors.email}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Mật khẩu"
                        type="password"
                        name="password"
                        value={formData.values.password}
                        isError={!!formData.errors.password}
                        message={formData.errors.password}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-input mb-50">
                    <Input
                        placeholder="Xác nhận mật khẩu"
                        type="password"
                        name="password_confirm"
                        value={formData.values.password_confirm}
                        isError={!!formData.errors.password_confirm}
                        message={formData.errors.password_confirm}
                        onChange={formData.handleChange}
                    />
                </div>
                <Button className="action-danger-1 btn-register" type="submit" isNa={authState.isFetching}>Đăng ký</Button>
                <div className="mt-25 flex-left">
                    <Link to="/login" className="text-link s-16 text-link-hover ">Đã có tài khoản, đăng nhập</Link>
                </div>
            </form>
        </RegisterWrapper>
    )
}

export default Register